import {createSelector} from "@reduxjs/toolkit";
import {ReducerStatuses} from "services/utils/utils";

const baseState = state => state.notifications.count;

export const notificationCountLoadingSelector = createSelector([baseState], (state) => {
    return state.status === ReducerStatuses.LOADING;
});

export const notificationCountData = createSelector([baseState], (state) => {
    return state.count;
});
